if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        const allMediaElements = this.querySelectorAll(`[data-media-id]`);

        allMediaElements.forEach((element) => {
          if (element.getAttribute('data-media-id') === activeMediaId) {
            element.classList.add('active');
            element.style.display = 'block';
          } else {
            element.classList.remove('active');
            element.style.display = 'none'; 
          }
        });

        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.offsetLeft - container.clientWidth / 2) + (activeMedia.clientWidth / 2);

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
